const {
  GET_ORDER_DATA_REQUEST,
  GET_ORDER_DATA,
  GET_ORDER_DATA_ERROR,
} = require('../actions/types');

const initialState = {
  loading: true,
  data: null,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ORDER_DATA_REQUEST:
      return {
        ...state,
        loading: false,
        data: null,
        error: null,
      };
    case GET_ORDER_DATA:
      return {
        ...state,
        loading: false,
        data: payload,
        error: null,
      };
    case GET_ORDER_DATA_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
